
import React from 'react';
import { Card } from "@/components/ui/card";
import { format } from 'date-fns';
import { Lead } from '@/types/leads';
import { Funnel } from '@/types/funnels';

interface DailySummaryProps {
  leads: Lead[];
  funnels: Funnel[];
  lastUpdated: Date;
}

const DailySummary: React.FC<DailySummaryProps> = ({ leads, funnels, lastUpdated }) => {
  const generateSummary = () => {
    const totalLeads = leads.length;
    const wonLeads = leads.filter(lead => lead.status === 'won').length;
    const activeLeads = leads.filter(lead => lead.status === 'in_progress').length;
    const totalLeadValue = leads.reduce((total, lead) => {
      const value = lead.lead_value ? parseFloat(lead.lead_value) : 0;
      return total + value;
    }, 0);
    const activeFunnels = funnels.filter(funnel => funnel.runtime && funnel.runtime !== '').length;

    return {
      totalLeads,
      wonLeads,
      activeLeads,
      totalLeadValue,
      activeFunnels,
    };
  };

  const summary = generateSummary();

  return (
    <Card className="p-6 mb-8 bg-gray-50">
      <div className="space-y-4">
        <div className="flex justify-between items-start">
          <h2 className="text-lg font-semibold text-gray-900">Daily Summary</h2>
          <p className="text-sm text-gray-500">
            Last updated: {format(lastUpdated, 'PPpp')}
          </p>
        </div>
        <p className="text-gray-700 leading-relaxed">
          Today we have {summary.activeLeads} active leads in progress and have won {summary.wonLeads} deals. 
          The total pipeline value is ${summary.totalLeadValue.toLocaleString('en-US', { minimumFractionDigits: 2 })}, 
          spread across {summary.totalLeads} total leads. We currently have {summary.activeFunnels} active sales funnels 
          running campaigns.
        </p>
        <p className="text-xs text-gray-500 italic mt-2">
          This summary was generated using AI
        </p>
      </div>
    </Card>
  );
};

export default DailySummary;
